<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'level'"></sideBar>
				<div class="v-content-wrapper">
					<div class="v-content-container">

						<!-- Store Level Overview Header -->
						<div class="store-level-header">
							<img src="../../assets/images/level/level.png" alt="Store Level Background"
								class="bg-image" />
							<h1 class="title">{{$t('common.storeleveloverview')}}</h1>
						</div>

						<!-- Grade Cards -->
						<div class="grade-cards-container">
							<div v-for="(grade, index) in grades" :key="index" class="grade-card">
								<h3 class="grade-title">{{ grade.levelName }}</h3>
								<ul class="features-list">
									<li class="feature-item">
										<span class="check-icon">✓</span>
										{{$t('common.maximumprofit')}}:{{ grade.profitRate }}%
									</li>
									<li class="feature-item">
										<span class="check-icon">✓</span>
										{{$t('common.deliverytime')}}:{{ grade.deliverySpeed }} {{$t('common.days')}}
									</li>
									<li class="feature-item">
										<span class="check-icon">✓</span>
										{{$t('common.weeklyvisitors')}}: {{ grade.weeklyvisitors }}
									</li>
									<li class="feature-item">
										<span class="check-icon">✓</span>
										{{$t('common.platformhome')}}: {{ grade.homeTime }} {{$t('common.days')}}
									</li>

								</ul>
								<div class="recharge-info">
									<span v-if="grade.money == 0" class="free-label">
										{{$t('common.freeofcharge')}}
									</span>
									<span v-else>
										{{$t('common.rechargeamount')}}: <strong>${{ grade.money }}</strong>
									</span>
								</div>
							</div>
						</div>




					</div>
				</div>
			</div>
			<div class="occupy-space"></div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		levelList
	} from '../../api/level'


	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				grades: [{
						title: 'Grade C',
						features: [
							'Maximum Profit: 20%',
							'Delivery Time: 15 Days',
							'Weekly Visitors: 1500',
							'Platform Home: 0 Days'
						],
						rechargeAmount: 'Free of Charge'
					},
					{
						title: 'Grade B',
						features: [
							'Maximum Profit: 22%',
							'Delivery Time: 10 Days',
							'Weekly Visitors: 3500',
							'Platform Home: 0 Days'
						],
						rechargeAmount: '100000.00'
					},
					{
						title: 'Grade A',
						features: [
							'Maximum Profit: 25%',
							'Delivery Time: 7 Days',
							'Weekly Visitors: 6000',
							'Platform Home: 10 Days'
						],
						rechargeAmount: '300000.00'
					},
					{
						title: 'Grade S',
						features: [
							'Maximum Profit: 30%',
							'Delivery Time: 7 Days',
							'Weekly Visitors: 10000',
							'Platform Home: 30 Days'
						],
						rechargeAmount: '1000000.00'
					}
				],
				tabList: [{
						title: this.$t('home.today')
					},
					{
						title: this.$t('home.yesterday')
					},
					{
						title: this.$t('home.last7days')
					},
					{
						title: this.$t('home.last30days')
					},
				],
				tabIndex: 0,

			}
		},
		mounted() {
			this.getLevelList();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},

			getLevelList() {
				levelList().then(res => {
					if (res.code === 200) {
						this.grades = res.data;
					}
				})
			},
			changeTab(index) {
				this.tabIndex = index
			},

		}
	}
</script>

<style scoped>
	@import url("../../assets/css/level.css");
</style>
<style scoped>
	.v-content-wrapper {
		margin: 0 10px 0 10px;
	}

	/* Store Level Header */
	.store-level-header {
		position: relative;
		width: 100%;
		height: 180px;
		overflow: hidden;
		border-radius: 8px;
		margin-bottom: 20px;
	}

	.bg-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.title {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 2rem;
		font-weight: bold;
		color: #000;
		text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
		z-index: 1;
	}

	/* Grade Cards Container */
	.grade-cards-container {
		display: flex;
		flex-wrap: nowrap;
		gap: 20px;
		justify-content: center;
		padding: 0px;
		justify-content: flex-start;
	}

	.grade-card {
		background-color: #fff;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		padding: 5px 20px 25px;
		width: calc(25% - 10px);
		box-sizing: border-box;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}

	.grade-card:hover {
		transform: translateY(-5px);
	}

	.grade-title {
		text-align: center;
		font-size: 1.2rem;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.features-list {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.feature-item {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		font-size: 0.9rem;
		justify-content: center;
	}

	.check-icon {
		color: #4CAF50;
		margin-right: 8px;
		font-weight: bold;
	}

	.recharge-info {
		margin-top: 20px;
		text-align: center;
		font-weight: bold;
	}

	.free-label {
		color: #4CAF50;
	}

	/* Responsive Design for H5 */
	@media (max-width: 768px) {
		.grade-cards-container {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}

		.grade-card {
			width: 100%;
		}

		.title {
			font-size: 1.5rem;
		}
	}

	@media (max-width: 480px) {
		.grade-cards-container {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}

		.grade-card {
			width: 100%;
		}

		.store-level-header {
			height: 150px;
		}

		.title {
			font-size: 1.2rem;
		}

		.grade-title {
			font-size: 1rem;
		}

		.feature-item {
			font-size: 0.8rem;
		}
	}
</style>
